import { getGroupSelectorTitle, isAlumnosCourse, isCpaCourse, isFuncionariosCourse, isKioskCourse, } from "@/utils/parseCourseCode";
const CARGO_I18N_KEYS = {
    DRIVER: "roles.cargo.driver",
    GATE_GUARD: "roles.cargo.gateGuard",
    INSPECTOR: "roles.cargo.inspector",
    INSPECTOR_GENERAL: "roles.cargo.inspectorGeneral",
    SCHOOL_ADMIN: "roles.cargo.schoolAdmin",
    RECTOR: "roles.cargo.rector",
    DOCENTE: "roles.cargo.teacher",
};
export const getLocalizedGroupSelectorTitle = (course, t) => {
    if (!course)
        return "";
    if (isFuncionariosCourse(course)) {
        const cargoCode = String(course.cargo_code ?? "")
            .trim()
            .toUpperCase();
        const cargoKey = CARGO_I18N_KEYS[cargoCode];
        const cargoLabel = cargoKey && t(cargoKey) !== cargoKey
            ? t(cargoKey)
            : String(course.cargo_label ?? "").trim();
        const staffLabel = t("roles.funcionario");
        return cargoLabel ? `${staffLabel} · ${cargoLabel}` : staffLabel;
    }
    if (isAlumnosCourse(course))
        return "Alumno";
    if (isKioskCourse(course))
        return t("roles.kioskUsers");
    if (isCpaCourse(course))
        return t("roles.parentsCenter");
    return getGroupSelectorTitle(course);
};
